/** 关联页面 tag 用稳定 tone（按 id hash），避免模板里 Math.random 每次渲染变色。 */
const PAGE_TAG_TONES = 6

export function getPageTagTone(pageId) {
  const raw = String(pageId == null ? '' : pageId)
  let hash = 0
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash * 31 + raw.charCodeAt(i)) >>> 0
  }
  return hash % PAGE_TAG_TONES
}

/** 分类类型 pill：常见类型走固定色，其余 neutral */
export function getClassifyTypeVariant(typeName) {
  const key = String(typeName || '').trim().toLowerCase()
  if (!key) return 'neutral'
  if (/ai|assistant|角色/.test(key)) return 'violet'
  if (/link|链接/.test(key)) return 'link'
  if (/wallpaper|壁纸|theme|主题/.test(key)) return 'image'
  if (/video|视频/.test(key)) return 'video'
  if (/audio|音频|music|音乐/.test(key)) return 'audio'
  return 'neutral'
}

export function getVisiblePages(pages) {
  return (pages || []).slice(0, 2)
}

export function getHiddenPageCount(pages) {
  return Math.max(0, (pages || []).length - 2)
}
